export const environment = {
  production: true,
  apiPath: 'https://cm-api-production-f410f6a49317.herokuapp.com/graphql',
  downloadPath: 'https://cm-downloads-production-7ea309ea2a9b.herokuapp.com/api/downloads'
};


// https://cm-api-staging-5b9851c74b46.herokuapp.com/
